import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-016d925e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-4 is-flex is-align-items-center is-justify-content-space-between" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title is-size-4 mb-0" }, " Cube projects ", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "panel-block" }
const _hoisted_6 = {
  key: 0,
  class: "panel"
}
const _hoisted_7 = {
  key: 1,
  class: "has-text-grey"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hydra_operation_button = _resolveComponent("hydra-operation-button")!
  const _component_cc_hydra_operation_form = _resolveComponent("cc-hydra-operation-form")!
  const _component_cube_projects_item = _resolveComponent("cube-projects-item")!
  const _component_loading_block = _resolveComponent("loading-block")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_page_content = _resolveComponent("page-content")!

  return (_openBlock(), _createBlock(_component_page_content, { class: "container-narrow" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.projectsCollection)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_hydra_operation_button, {
                operation: _ctx.projectsCollection.actions.create,
                to: { name: 'CubeProjectCreate', query: this.$route.query },
                variant: "default",
                size: "normal",
                label: _ctx.projectsCollection.actions.create.title
              }, null, 8, ["operation", "to", "label"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.projectsCollection)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_cc_hydra_operation_form, {
                inline: "",
                clearable: "",
                ".operation": _ctx.operation,
                ".resource": _ctx.searchParams,
                ".shape": _ctx.shape,
                onSubmit: _ctx.onSearch,
                "submit-when-cleared": ""
              }, null, 8, [".operation", ".resource", ".shape", "onSubmit"])
            ]),
            (_ctx.projects.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
                    return (_openBlock(), _createBlock(_component_cube_projects_item, {
                      key: project.id.value,
                      project: project,
                      class: "panel-block"
                    }, null, 8, ["project"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_7, " No projects yet "))
          ]))
        : (_openBlock(), _createBlock(_component_loading_block, { key: 1 })),
      (_ctx.projectsCollection)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}